import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {isMembersVisible} from '../../../selectors/single-settings'
import {Members} from '../../members'
import {SingleEventMembersProps} from './interfaces'
import s from './members.scss'

export const SingleEventMembers = ({event, onImage}: SingleEventMembersProps) => {
  const membersVisible = useWidgetState(state => isMembersVisible(state, event))

  return membersVisible ? (
    <div className={s.members} data-hook="ev-members">
      <Members event={event} singleLayout={true} onImage={onImage} />
    </div>
  ) : null
}
